import { error } from "@/state/config";
import type { FunctionalComponent } from "preact";
import { version } from "scripts/version";
import Logo from "./Logo";

const ErrorComponent: FunctionalComponent = () => {
    const noAccessRights = error.value instanceof Error ? error.value.name.includes("NotAllowedError") : false;
    const errorMsg = error.value instanceof Error ? error.value.message || "Unknown" : "Unkown";

    return (
        <div class="flex h-screen flex-col justify-center">
            <Logo word1="Stream" word2="Cast" />
            <h1 class="mx-auto mt-10 font-semibold text-white text-xl tracking-tighter">An error occurred</h1>
            {noAccessRights && (
                <p class="mx-auto max-w-1/2 text-center text-white italic tracking-tighter sm:max-w-64">
                    StreamCast needs access to the Camera and Micro to be able to show the content.
                </p>
            )}
            {!noAccessRights && (
                <p class="mx-auto max-w-1/2 text-center text-white italic tracking-tighter sm:max-w-64">
                    ErrorMessage:
                    <br />
                    {errorMsg}
                </p>
            )}

            <p class="mx-auto mt-10 text-sm text-white tracking-tighter">v{version()}</p>
        </div>
    );
};

export default ErrorComponent;
